<template>
	<div class="production_show">
		<div class="production">
			<div class="production_box">
				<div class="production-list">
					<ProductCard v-for="(item, index) in production_img" :key="index" :item="item"
						:yellow="index % 2 === 1" />
				</div>
			</div>
		</div>

		<div class="about_us">
			<img class="about_img" src="../assets/img/index/黑色背景图2.jpg" alt='About Us' />
			<div class="eg_about">About <span style="color: #fff;">Us</span>
			</div>
			<div class="cn_about">关于康和达</div>
			<div class="content">
				<div>康和达是一家聚焦生命科学领域实验室设备的公司，为客户提供细胞研究的高端设备，</div>
				<div>主营自动细胞计数仪、活细胞成分析仪及相关耗材。</div>
				<div>借助自动化设备帮助客户简化细胞研究操作，提高相关效率，让您的细胞研究更简单！</div>
			</div>
			<LinkButton class="lb4" to="/ProductCenter" text="产品信息" variant="dark"></LinkButton>
			<LinkButton class="lb5" to="/ContactUs" text="联系我们" variant="yellow-noborder"></LinkButton>
		</div>
		<img class="customer_img" src="../assets/img/index/标杆客户.png" alt="标杆客户" />
		<div class="customer_box">
			<img class="all_customer_img" src="../assets/img/index/customers/客户.png" alt="所有客户" />
		</div>
		<div class="grid_container">
			<div class="benchmark_customers">
				<div class="customer" v-for="(item, index) in customers_img" :key="index">
					<el-card class="customers_card" :body-style="{ padding: '0px' }" shadow="hover">
						<el-tooltip class="item" effect="dark" :content="item.desc" placement="bottom">
							<img class="tip" :src="item.path" />
						</el-tooltip>
					</el-card>
				</div>
				<div class="customer_c" v-for="(item, index) in customers_list" :key="item.index">
					<el-card class="customers_card" :body-style="{ padding: '0px' }" shadow="hover">
						<div class="customer_name">{{item.name}}</div>
					</el-card>
				</div>
			</div>
		</div>
		<div class="contact_us">
			<img class="y_background2" src="../assets/img/index/黄色背景图2.jpg" />
			<div class="svg_container">
				<img src="../assets/img/index/tel.png" class="tel_img" />
				<img src="../assets/img/index/email.png" class="email_img" />
				<img src="../assets/img/index/locate.png" class="locate_img" />
				<img src="../assets/img/index/locate.png" class="locate_img" />
				<p class="company_info top">18118128515</p>
				<p class="company_info">info@kaltec.cn</p>
				<p class="company_info">上海市奉贤区星火开发区莲塘路251号8幢</p>
				<p class="company_info">江苏省苏州市虎丘区富春江路188号医疗器械产业园加速器1号楼1004室</p>
			</div>
			<LinkButton class="lb6" to="/ProductCenter" text="产品信息" variant="dark-ghost"></LinkButton>
			<LinkButton class="lb7" to="/ContactUs" text="联系我们" variant="yellow-translucent"></LinkButton>
		</div>
		<div class="white"></div>
	</div>
</template>

<script>
	import LinkButton from './public/LinkButton.vue'
	import ProductCard from './public/ProductCard.vue'
	import { homeProducts } from '../constants/products'
	import { customerLogos, customerNames } from '../constants/customers'
	export default {
		name: 'ProductionShow',
		components: {
			LinkButton,
			ProductCard
		},
		data() {
			return {
				production_img: homeProducts,
				customers_img: customerLogos,
				customers_list: customerNames
			}
		}
	}
</script>

<style scoped>
	.white {
		height: 1px;
		width: 100%;
		background-color: #fff;
	}

	.grid_container {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.benchmark_customers {
		display: grid;
		grid-template-columns: 270px 270px 270px 270px;
		grid-gap: 20px;
		grid-template-rows: 110px 110px 110px;
	}

	.customer {
		padding: 10px;
		border: 1px solid #ccc;
		text-align: center;
		border: none;
	}

	.customers_card {
		height: 110px;
		width: 270px;
		border-radius: 5px;
	}

	/* 行高用 minmax 而非固定值：简介文案行数不一（如混合细胞为两行）时行会自动撑高，
	   否则超出部分会溢出并被下方区块遮挡 */
	.production-list {
		display: grid;
		grid-template-columns: 400px 400px 400px;
		grid-auto-rows: minmax(520px, auto);
		grid-gap: 20px;
		text-align: center;
	}

	img {
		outline-width: 0px;
		vertical-align: top;
		background-size: cover;
	}

	.about_img {
		width: 100%;
		height: 576px;
	}

	.about_us {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		width: 100%;
	}

	.eg_about {
		margin-bottom: 450px;
		margin-right: 270px;
		transform: translate(50%, 50%);
		position: absolute;
		color: #FFF100;
		font-size: 60px;
	}

	.cn_about {
		margin-bottom: 290px;
		margin-right: 200px;
		transform: translate(50%, 50%);
		position: absolute;
		color: #fff;
		font-size: 40px;
	}

	.content {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		transform: translateY(-30px);
		position: absolute;
		color: #fff;
		font-size: 20px;
		line-height: 2;
		margin-top: 100px;
		letter-spacing: 1px;
	}

	.lb4 {
		margin-left: -360px;
		margin-top: 50px;
		transform: translate(50%, 300%);
		position: absolute;
	}

	.lb5 {
		margin-left: 80px;
		margin-top: 50px;
		transform: translate(50%, 300%);
		position: absolute;
	}

	.contact_us {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		margin-top: 80px;
	}

	.svg_container {
		display: grid;
		position: absolute;
		grid-template-columns: 23vw 23vw 24vw 24vw;
		grid-template-rows: 60px;
		text-align: center;
		grid-column-gap: 20px;
		grid-row-gap: 20px;
		margin-bottom: 50px;
		margin-right: 80px;
	}

	.tel_img,
	.email_img,
	.locate_img {
		height: 70px;
		margin-left: 9.5vw;
	}

	.lb6 {
		margin-left: -360px;
		transform: translate(50%, 300%);
		position: absolute;
	}

	.lb7 {
		margin-left: 80px;
		transform: translate(50%, 300%);
		position: absolute;
	}

	.p_card {
		height: 38vh;
		width: 29vw;
		border-radius: 30px;
	}

	.p_card:hover {
		transform: scale(1.05);
	}

	.production_box {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.customer_img {
		width: 100%;
		margin-top: 50px;
		margin-bottom: 80px;
	}

	.customer_c {
		margin-left: 0.6em;
		margin-top: 0.5em;
	}

	.tip {
		height: 110px;
		width: 270px;
	}

	.customer_name {
		height: 110px;
		width: 270px;
		text-align: center;
		margin-top: 1.8em;
		font-family: KaiTi;
		font-weight: bold;
		font-size: 1.25em;
		white-space: pre-wrap;
	}

	.y_background2 {
		height: 450px;
		width: 100%;
	}

	.company_info .top {
		font-size: 24px;
		font-weight: 500;
		margin-left: 50px;
	}

	.company_info {
		font-size: 24px;
		font-weight: 500;
	}

	.customer_box {
		display: none;
	}

	@media screen and (max-width: 1150px) {
		.production-list {
			display: grid;
			grid-template-columns: 400px 400px;
			grid-auto-rows: minmax(500px, auto);
			grid-gap: 20px;
			text-align: center;
		}

		.about_img {
			height: calc(200px + 10vw);
			width: 100%;
		}

		.eg_about {
			font-size: 2rem;
			margin-bottom: 280px;
			margin-right: 180px;
		}

		.cn_about {
			font-size: 2rem;
			margin-bottom: 180px;
		}

		.content {
			font-size: 1rem;
		}

		.lb4 {
			display: none;
		}

		.lb5 {
			display: none;
		}

		.benchmark_customers {
			display: grid;
			grid-template-columns: 270px 270px 270px;
			grid-gap: 20px;
			grid-template-rows: 100px 100px 100px;
		}

		.customer_c {
			margin-top: 0;
		}

		.y_background2 {
			width: 100%;
			height: auto;
		}

		.lb6 {
			display: none;
		}

		.lb7 {
			display: none;
		}

		.svg_container {
			display: grid;
			position: absolute;
			grid-template-columns: 200px 200px 200px 200px;
			grid-template-rows: 60px;
			text-align: center;
			grid-column-gap: 20px;
			grid-row-gap: 0;
			margin-right: 80px;
			margin-top: 60px;
		}

		.svg_container p {
			font-size: 1rem;
		}

		.tel_img,
		.email_img,
		.locate_img {
			height: 3rem;
			margin-left: 8vw;
		}
	}

	@media screen and (max-width: 800px) {
		.production-list {
			display: grid;
			grid-template-columns: 400px;
			grid-auto-rows: minmax(400px, auto);
			text-align: center;
		}

		.eg_about {
			font-size: 1rem;
			margin-bottom: 120px;
			margin-right: 70px;
		}

		.cn_about {
			font-size: 1rem;
			margin-bottom: 70px;
			margin-right: 85px;
		}

		.content {
			font-size: 0.4rem;
			letter-spacing: 0;
		}

		.customer_img {
			margin-top: 20px;
			margin-bottom: 10px;
		}

		.benchmark_customers {
			display: none;
		}

		.customer_box {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.all_customer_img {
			width: 90%;
			height: auto;
		}

		.contact_us {
			margin-top: 20px;
		}

		.y_background2 {
			height: 200px;
			width: 100%;
		}

		.svg_container {
			display: grid;
			position: absolute;
			grid-template-columns: 100px 100px 100px 100px;
			grid-template-rows: 40px;
			text-align: center;
			grid-column-gap: 5px;
			margin-right: 20px;
			margin-top: 70px;
		}

		.svg_container p {
			font-size: 0.7rem;
		}

		.tel_img,
		.email_img,
		.locate_img {
			height: 2rem;
			margin-left: 8vw;
		}
	}

	@media screen and (max-width: 280px) {
		.about_img {
			height: calc(200px + 10vw);
			width: 100%;
		}
	}
</style>